module.exports = __webpack_public_path__ + "img/vi-top-bg.7a06253c.png";